export default __webpack_public_path__ + "static/center-de-7487c4d7642105cec88d1844aafac309.webp";